import styled from 'styled-components';

export const Sidebar = styled.div`
  display: none;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: block;
    height: 300px;
    position: sticky;
    top: 0;
  }
`;

export const Section = styled.button`
  margin-bottom: 16px;
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 14px;
`;

export const SidebarSubtitle = styled.p`
  font-size: 16px;
  line-height: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  color: ${(props) => props.theme.colors['neutral-100']};
`;
